module.exports = __webpack_public_path__ + "static/media/in-icon.c5aacca6.svg";